export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [3,[2]],
		"/(app)/clusters": [4,[2]],
		"/(app)/clusters/import": [7,[2]],
		"/(app)/clusters/[uuid]": [5,[2]],
		"/(app)/clusters/[uuid]/edit": [6,[2]],
		"/(app)/federation": [8,[2]],
		"/(app)/federation/join": [9,[2]],
		"/(auth)/login": [26],
		"/(auth)/logout": [27],
		"/(app)/meta-deployments": [10,[2]],
		"/(app)/meta-deployments/create": [12,[2]],
		"/(app)/meta-deployments/[uuid]": [11,[2]],
		"/(app)/monitoring": [13,[2]],
		"/(app)/settings": [14,[2]],
		"/(app)/tenants": [15,[2]],
		"/(app)/tenants/[uuid]": [16,[2]],
		"/(app)/tenants/[uuid]/edit": [17,[2]],
		"/(app)/users": [18,[2]],
		"/(app)/users/create": [21,[2]],
		"/(app)/users/[uuid]": [19,[2]],
		"/(app)/users/[uuid]/edit": [20,[2]],
		"/(app)/virtual-clusters": [22,[2]],
		"/(app)/virtual-clusters/create": [24,[2]],
		"/(app)/virtual-clusters/[uuid]": [23,[2]],
		"/(app)/workloads": [25,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';